// ═══════════════════════════════════════════════
//   CATALOG — Dokomi 2026 product catalog viewer.
//
//   Single window (w-catalog) shows the 6 catalogue pages
//   (acrylic / prints / paper / textile / stickers) as a grid
//   of thumbnails. Clicking a thumb opens a fullscreen lightbox
//   overlay so visitors can see prices/details in HD with prev /
//   next arrows and Esc to close.
//
//   Source PDF is the original Telegram-shared catalog; pages are
//   rendered at 1190x1684 JPG q85 (~400 KB each, lazy-loaded).
//
//   Exposes (global):
//     openCatalog()                  — open the catalog window
//     catalogOpenLightbox(idx)       — show page idx in lightbox
//     catalogCloseLightbox()         — close lightbox
//     catalogPrev() / catalogNext()  — navigate inside lightbox
// ═══════════════════════════════════════════════

const {SFX} = window;

// Order matters — drives the lightbox prev/next navigation.
const CATALOG_PAGES = [
    {src: 'assets/catalog/catalog_page_1_acrylic.jpg',           label: 'Acrylic — Standees & Keychains'},
    {src: 'assets/catalog/catalog_page_2_acrylic_keychains.jpg', label: 'Acrylic — Keychains & Phone Charms'},
    {src: 'assets/catalog/catalog_page_3_prints.jpg',            label: 'Prints — A4 / A5'},
    {src: 'assets/catalog/catalog_page_4_paper.jpg',             label: 'Paper — Cards & Postcards'},
    {src: 'assets/catalog/catalog_page_5_textile.jpg',           label: 'Textile — Tote bags & Pins'},
    {src: 'assets/catalog/catalog_page_6_stickers.jpg',          label: 'Stickers'},
];

let catalogLightboxIdx = -1;

function openCatalog() {
    window.openWin('w-catalog');
    buildCatalog();
}

// Build is idempotent; the dataset flag avoids re-rendering each open.
function buildCatalog() {
    const grid = document.getElementById('catalog-grid');
    if (!grid || grid.dataset.built === '1') return;
    grid.innerHTML = CATALOG_PAGES.map((p, i) => `
        <button class="catalog-card" type="button" onclick="catalogOpenLightbox(${i})">
            <div class="catalog-card-img"><img src="${p.src}" alt="${p.label}" loading="lazy"></div>
            <div class="catalog-card-label">${p.label}</div>
        </button>
    `).join('');
    grid.dataset.built = '1';
}

function catalogOpenLightbox(idx) {
    if (idx < 0 || idx >= CATALOG_PAGES.length) return;
    catalogLightboxIdx = idx;
    const lb = document.getElementById('catalog-lightbox');
    const img = document.getElementById('catalog-lightbox-img');
    const cap = document.getElementById('catalog-lightbox-cap');
    img.src = CATALOG_PAGES[idx].src;
    img.alt = CATALOG_PAGES[idx].label;
    cap.textContent = `${idx + 1} / ${CATALOG_PAGES.length} — ${CATALOG_PAGES[idx].label}`;
    lb.classList.add('on');
    SFX.play('open');
}

function catalogCloseLightbox() {
    const lb = document.getElementById('catalog-lightbox');
    if (!lb || !lb.classList.contains('on')) return;
    lb.classList.remove('on');
    catalogLightboxIdx = -1;
    SFX.play('close');
}

function catalogPrev() {
    if (catalogLightboxIdx < 0) return;
    catalogOpenLightbox((catalogLightboxIdx - 1 + CATALOG_PAGES.length) % CATALOG_PAGES.length);
}

function catalogNext() {
    if (catalogLightboxIdx < 0) return;
    catalogOpenLightbox((catalogLightboxIdx + 1) % CATALOG_PAGES.length);
}

document.addEventListener('keydown', e => {
    if (catalogLightboxIdx < 0) return;
    if      (e.key === 'Escape')     catalogCloseLightbox();
    else if (e.key === 'ArrowLeft')  catalogPrev();
    else if (e.key === 'ArrowRight') catalogNext();
});

window.openCatalog          = openCatalog;
window.buildCatalog         = buildCatalog;
window.catalogOpenLightbox  = catalogOpenLightbox;
window.catalogCloseLightbox = catalogCloseLightbox;
window.catalogPrev          = catalogPrev;
window.catalogNext          = catalogNext;
